import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { hasAnyRole } from "../lib/roles.js";
import { RadarLoaderLarge } from "./ui";

function FullscreenLoader() {
  return (
    <div className="min-h-screen bg-background-dark flex items-center justify-center">
      <RadarLoaderLarge />
    </div>
  );
}

/**
 * RoleRoute — generic role-based route guard.
 *
 * Renders `children` only when the authenticated user's role is in `allow`.
 * Redirects to /login when there is no user, and to `fallback` (default "/")
 * when the user is authenticated but lacks the required role.
 *
 * @param {object} props
 * @param {string[]} props.allow      Roles allowed to access the route.
 * @param {string}   [props.fallback] Path to redirect to when role mismatched.
 * @param {React.ReactNode} props.children
 */
export default function RoleRoute({ allow, fallback = "/", children }) {
  const { user, loading } = useAuth();

  if (loading) return <FullscreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasAnyRole(user, allow)) return <Navigate to={fallback} replace />;

  return children;
}
